import epoch1 from './epoche-1';
import epoch2 from './epoche-2';
import epoch3 from './epoche-3';
import epoch4 from './epoche-4';
import epoch5 from './epoche-5';

let milestoneCount = 1;
let id = 0;

// add milesotne number to milestone items
const epochs = [epoch1, epoch2, epoch3, epoch4, epoch5].map(
  (epoch, epochIndex) => {
    epoch.id = epochIndex.toString();

    epoch.items = epoch.items.map(item => {
      if (item.milestone) {
        item.milestoneNumber = milestoneCount++;
      }

      item.id = `${epochIndex}--${id++}`;
      item.epochId = epochIndex;

      return item;
    });

    return epoch;
  }
);

export default epochs;
